module.exports = __webpack_public_path__ + "img/pd-img5.bc8579cf.png";